module.exports = __webpack_public_path__ + "img/khamsuckhoe.ad7c3f85.jpg";